import { IInputNode, QuestionNode, isValidNumber } from '../../../actionCard'

export class BaseNumberQuestionNode extends QuestionNode implements IInputNode<number | undefined> {
  public override setStringValue(value?: string): void {
    const parsedValue = Number.parseFloat(value ?? '')
    this.setValue(isNaN(parsedValue) ? undefined : parsedValue)
  }

  public override isInputEmpty(): boolean {
    return !isValidNumber(this.getValue())
  }
}
